class CategoryHierarchy {
  constructor(root) {
    this.root = root;
    this.map = this.readMap();
    if (!this.map) return;
    this.enhance();
  }

  readMap() {
    const node = this.root.querySelector('[data-category-hierarchy]');
    if (!node) return null;
    try { return JSON.parse(node.textContent.trim()); }
    catch (e) { return null; }
  }

  getCategoryList() {
    const inputs = this.root.querySelectorAll(
      'input[name*="filter.p.m.custom.product_category"]'
    );
    if (!inputs.length) return null;
    return inputs[0].closest('.facets__inputs-list') || null;
  }

  handleOf(input) {
    // Native facet input value is the value handle, e.g. "table-lamps"
    return (input.value || '').trim();
  }

enhance() {
    const list = this.getCategoryList();
    if (!list) return;

    const childToParent = this.map;
    const rows = Array.from(list.children);

    // Build an index and assign order numbers.
    // Mains keep their natural index; subs get their parent's index + fractional offset.
    const indexByGid = {};
    rows.forEach((row, i) => {
      const input = row.querySelector('input');
      if (!input) return;
      indexByGid[input.value] = i;
    });

    let subCounter = {};
    rows.forEach((row, i) => {
      const input = row.querySelector('input');
      if (!input) return;
      const gid = input.value;
      const parentGid = childToParent[gid];

      if (parentGid) {
        // It's a SUB
        row.setAttribute('data-cat-role', 'sub');
        row.setAttribute('data-cat-parent', parentGid);
        const base = indexByGid[parentGid] != null ? indexByGid[parentGid] : i;
        subCounter[parentGid] = (subCounter[parentGid] || 0) + 1;
        row.style.order = (base * 100) + subCounter[parentGid];
      } else {
        // It's a MAIN
        row.setAttribute('data-cat-role', 'main');
        row.setAttribute('data-cat-handle', gid);
        row.style.order = i * 100;
      }
    });

    // Reveal logic — unchanged concept, but no node moving
    const syncMain = (mainGid) => {
      const mainRow = list.querySelector(`[data-cat-handle="${CSS.escape(mainGid)}"]`);
      if (!mainRow) return;
      const mainInput = mainRow.querySelector('input');
      const subs = list.querySelectorAll(`[data-cat-parent="${CSS.escape(mainGid)}"]`);
      let anySubChecked = false;
      subs.forEach((s) => { const i = s.querySelector('input'); if (i && i.checked) anySubChecked = true; });
      const reveal = (mainInput && mainInput.checked) || anySubChecked;
      mainRow.classList.toggle('is-open', reveal);
      subs.forEach((s) => s.classList.toggle('is-revealed', reveal));
    };

    // Initial sync for all mains
    list.querySelectorAll('[data-cat-role="main"]').forEach((m) => {
      syncMain(m.getAttribute('data-cat-handle'));
    });

    // React to changes
    if (!list.__catBound) {
      list.addEventListener('change', (e) => {
        const input = e.target.closest('input');
        if (!input) return;
        const row = input.closest('[data-cat-role]');
        if (!row) return;
        if (row.getAttribute('data-cat-role') === 'main') {
          syncMain(row.getAttribute('data-cat-handle'));
        } else {
          syncMain(row.getAttribute('data-cat-parent'));
        }
      });
      list.__catBound = true;
    }

    list.setAttribute('data-cat-ready', 'true');
  }
}

function initCategoryHierarchy() {
  document.querySelectorAll('.facets__form')
    .forEach((form) => new CategoryHierarchy(form));
}

document.addEventListener('DOMContentLoaded', initCategoryHierarchy);
document.addEventListener('shopify:section:load', initCategoryHierarchy);

// Re-apply after Fabric's AJAX re-renders the facets
const facetObserver = new MutationObserver(() => {
  clearTimeout(window.__catHierTimer);
  window.__catHierTimer = setTimeout(initCategoryHierarchy, 50);
});

document.querySelectorAll('.facets__form-wrapper, facets-form-component')
  .forEach((node) => {
    facetObserver.observe(node, { childList: true, subtree: true });
  });